import { ApplicantInfo } from '../components/welcome/applicant-info';
import { DocumentRequirements } from '../components/welcome/document-requirements';
import { QuickOverview } from '../components/welcome/quick-overview';
import { IndividualOverview } from '../components/welcome/individual-overview';
import { toUrlSlug } from './common-utils';

const ROUTES = {
    LOGIN: '/welcome',
    SELECT_ENTITY: '/select-entity',
    WELCOME: {
        BASE: (journeyId: string): string =>`/journey/${journeyId}/welcome/`,
        "Client Onboarding":[
            { url: (journeyId: string) => { return ROUTES.WELCOME.BASE(journeyId) + 'applicant-info' }, componentFile: ApplicantInfo },
            { url: (journeyId: string) => { return ROUTES.WELCOME.BASE(journeyId) + 'quick-overview' }, componentFile: QuickOverview },
            { url: (journeyId: string) => { return ROUTES.WELCOME.BASE(journeyId) + 'docs' }, componentFile: DocumentRequirements }
        ],
        "Invited Individual":[
            { url: (journeyId: string) => { return ROUTES.WELCOME.BASE(journeyId) + 'individual-overview' }, componentFile: IndividualOverview },
        ],
    },
    genericTaskDetails: (journeyId: string, taskId: string): string => `/journey/${journeyId}/task/${taskId}`,
    genericTaskDetailsByName: (journeyName: string, taskName: string): string => `/journey/${toUrlSlug(journeyName)}/task/${toUrlSlug(taskName)}`,
    thankYou: '/thank-you',
    portal: '/portal'
};

export default ROUTES;
